/* eslint-disable eqeqeq */
import React, { useState, useEffect, useLayoutEffect, useCallback, useRef, lazy, Suspense } from 'react';
import ReactDOM from "react-dom/client"
import Navbar from './components_android/NavbarAndroid'
import Tasks from './pages_android/TasksAndroid'
import './css_android/style_android.css';
import './motion/motion.css';
// стили «Чатов» — в основном бандле: их скелет показывается до загрузки кода экрана
import './chat/chats_android.css';
import { createChatSocket } from './chat/chatSocket';
import { ChatApi } from './components_android/api/ChatApi';
import Celebration from './motion/Celebration';
import { celebrateEarned, celebrateSynced } from './motion/celebrate';
import { installPressFeedback } from './motion/pressFeedback';
import { installImageReveal } from './motion/imageReveal';
import { RouteSkeleton, rememberTelegramBound, isTelegramBoundCached } from './motion/Loading';
import moment from 'moment'
import 'moment/locale/ru'
import { getUrlParameter, getHttpParams, getRequestUrl } from './pages_android/custom_views/insta_custom_views/utils_android/UrlHelperAndroid';
import {saveRegistrCookie, getGoogleId, getRequestParams, getIsUpmobKey, isShowClose, saveApiKey, setCookie, saveBundle, getCookie} from './pages_android/custom_views/insta_custom_views/utils_android/CookieHelper'
import { registrationFailed, showAndroidToast } from './pages_android/custom_views/insta_custom_views/utils_android/AndroidMethods';
import { captureUrlAuth, installSessionFetch, setAuthFailedHandler, ensureSession, getSessionToken, saveSession, forgetWorker, getUrlGoogleToken, googleTokenSub } from './pages_android/custom_views/insta_custom_views/utils_android/WorkerSession';
import { YMInitializer } from 'react-yandex-metrika';
import { BrowserRouter, Routes, Route, useNavigate, useLocation, useNavigationType } from 'react-router-dom';
import { convertNeedReworkOrders, getAndroidVersion, getIsAndroid, getIsAndroidApp, getIsIosApp, isShowBottomMenu, Pages } from './pages_android/custom_views/insta_custom_views/utils_android/UtilsAndroid';
import BottomMenu from './components_android/BottomMenu';
import { UsersApi } from './components_android/api/UsersApi';
import Auth from './pages_android/Auth';
import { GoogleOAuthProvider } from "@react-oauth/google"
import Toast from './pages_android/custom_views/insta_custom_views/utils_android/Toast';
import { TasksApi } from './components_android/api/TasksApi';
import { RatingApi } from './components_android/api/RatingApi';
import RatingPopup from './pages_android/rating/RatingPopup';

// Code-splitting: эти экраны грузятся отдельными чанками по требованию,
// чтобы не раздувать стартовый бандл (важно для слабых WebView).
// lazyPage: после первой загрузки экрана (или предзагрузки в фоне, см. preloadPages)
// он рисуется сразу, без Suspense — переход не мигает пустым экраном.
function lazyPage(factory) {
    let Loaded = null;
    let promise = null;
    const load = () => {
        if (!promise) {
            promise = factory().then((module) => {
                Loaded = module.default;
                return module;
            }, (error) => {
                promise = null;          // сеть моргнула — в следующий раз попробуем снова
                throw error;
            });
        }
        return promise;
    };
    const LazyPage = lazy(load);
    function Page(props) {
        const Component = Loaded || LazyPage;
        return <Component {...props} />;
    }
    Page.preload = () => load().catch(() => {});
    return Page;
}
const ActiveTasks = lazyPage(() => import('./pages_android/ActiveTasksAndroid'))
const FinishedTasks = lazyPage(() => import('./pages_android/FinishedTasksAndroid'))
const Task = lazyPage(() => import('./pages_android/TaskAndroid'))
const Referals = lazyPage(() => import('./pages_android/ReferalsAndroid'))
const Payouts = lazyPage(() => import('./pages_android/PayoutsAndroid'))
const GetPayout = lazyPage(() => import('./pages_android/GetPayoutAndroid'))
const Support = lazyPage(() => import('./pages_android/SupportAndroid'))
const AuthInsta = lazyPage(() => import('./pages_android/AuthInstaAndroid'))
const EarnInsta = lazyPage(() => import('./pages_android/EarnInstaAndroid'))
const CustomTask = lazyPage(() => import('./pages_android/CustomTask'))
const EarnTikTok = lazyPage(() => import('./pages_android/EarnTikTok'))
const Profile = lazyPage(() => import('./pages_android/ProfileAndroid'))
const More = lazyPage(() => import('./pages_android/MoreAndroid'))
const NeedRework = lazyPage(() => import('./pages_android/NeedRework'))
const TaskNewAndroid = lazyPage(() => import('./pages_android/TaskNewAndroid'))
const TaskIos = lazyPage(() => import('./pages_android/TaskIos'))
const FileUploadPage = lazyPage(() => import('./pages_android/FIleUploadPage'))
const ReviewShotPage = lazyPage(() => import('./pages_android/ReviewShotPage'))
const RatingPage = lazyPage(() => import('./pages_android/rating/RatingPage'))
const LotteryPage = lazyPage(() => import('./pages_android/lottery/LotteryPage'))
const Chats = lazyPage(() => import('./pages_android/ChatsAndroid'))

// После старта, когда приложению нечего делать, тихо подгружаем код основных
// экранов — к моменту перехода он уже на месте.
const PRELOAD_ORDER = [CustomTask, Task, TaskNewAndroid, TaskIos, Profile, More, NeedRework, Chats,
    Payouts, GetPayout, FinishedTasks, Referals, Support, LotteryPage];
let pagesPreloaded = false;
function preloadPages() {
    if (pagesPreloaded) return;
    pagesPreloaded = true;
    const idle = window.requestIdleCallback
        ? (fn) => window.requestIdleCallback(fn, { timeout: 2500 })
        : (fn) => window.setTimeout(fn, 1200);
    let i = 0;
    const next = () => {
        if (i >= PRELOAD_ORDER.length) return;
        PRELOAD_ORDER[i++].preload().then(() => idle(next), () => idle(next));
    };
    idle(next);
}

// В WebView каждый console.log сериализуется и уходит через JNI-мост в logcat,
// что заметно тормозит интерфейс. В проде глушим отладочные логи, оставляя error/warn.
// На localhost логи сохраняются для разработки.
if (!window.location.href.includes("localhost")) {
    const noop = () => {};
    console.log = noop;
    console.debug = noop;
    console.info = noop;
}

// Вход исполнителя по ключу сессии (WorkerSession.js): токен Google забираем из адреса до
// Метрики и первых запросов, ключ сессии уходит заголовком во все запросы к API
captureUrlAuth();
installSessionFetch(null);

window.$moneyCount = 0.0;
moment.locale('ru')

// День по Москве (UTC+3) — как считает сервер рейтинга (rating.js), и сколько до московской полуночи
const MSK_MS = 3 * 3600000;
const mskDay = () => new Date(Date.now() + MSK_MS).toISOString().slice(0, 10);
const msUntilMskMidnight = () => {
    const msk = Date.now() + MSK_MS;
    return (Math.floor(msk / 86400000) + 1) * 86400000 - msk;
};
function Application() {
    const [needReworkTasks, setNeedReworkTasks] = useState([])
    useEffect(() => {
        const isUnauthorized = !getIsAndroidApp() && !getCookie("google_user_id") && !getUrlParameter("google_user_id");
        const currentPath = window.location.pathname;
        // Ссылки на файлы (например /youtube_icons/order_type_other.svg) — это не роуты
        // приложения, их нельзя перехватывать и редиректить на /tasks.
        if (/\.[a-z0-9]+$/i.test(currentPath)) {
            return;
        }
        const isAuthPath = currentPath.includes(Pages.auth);
        const isTasksPath = currentPath.includes(Pages.tasks);
        // ссылка на переписку (/chats?dialog=…) должна открыться, а не смениться списком заданий
        const isChatsPath = currentPath.includes(Pages.chats);
        const isValidRoute = Array.from(document.querySelectorAll('Route')).some(route => 
            route.props.path.replace('/', '') === currentPath.replace('/', '')
        );
        if (getUrlParameter("file_upload") == "true"){
            setState(prev => ({
                ...prev,
                done: true
            }));
            return
        }
        if (!getIsAndroidApp() && (currentPath === "/" || !isValidRoute) && !isAuthPath && !isUnauthorized && !isTasksPath && !isChatsPath) {
            window.location.href = Pages.tasks;
        }

        
    }, []);

    const getInitialState = () => {
        const hashId = !getGoogleId("google_user_id");
        const hasApiKey = getUrlParameter("api_key");
        const api_key = getUrlParameter("api_key") ? getUrlParameter("api_key") : getCookie("api_key");
        const webview_fits = getUrlParameter("webview_fits");
        if (webview_fits == "true" && !getCookie("webview_fits")){
            setCookie("webview_fits", "true")
        }
        const isUpmob = hasApiKey ? ["upmob", "upmob_rustore", "lexus", "QWT", "QWT2"].includes(api_key) : true;

        if (api_key) {
            saveApiKey(api_key);
        }

        return {
            count_money_r: 0.0,
            nick_name: "",
            photo_url: "",
            email: "",
            google_user_id: "",
            info: {},
            // страница загрузки файла открывается без сведений о пользователе
            done: getUrlParameter("file_upload") == "true",
            timestamp: "",
            isUpmob: hashId ? isUpmob : getIsUpmobKey(),
            // isUpmob: false,
            ref_id: "",
            isClose: hashId ? (hasApiKey ? getUrlParameter("api_key") : false) : isShowClose(),
            activeView: 'tasks',
            currentTask: {},
            backView: undefined,
            isMenuOpened: false,
            instagram_user_name: "",
            isRegistered: !hashId
        };
    };
    // const androidVersion = getAndroidVersion()
    // console.log("androidVersion = ", androidVersion)
    // Ленивая инициализация: getInitialState содержит побочные эффекты
    // (saveApiKey, setCookie) — передаём ссылку, чтобы React вызвал её один раз
    // при монтировании, а не на каждом рендере.
    const [state, setState] = useState(getInitialState);
    const [toastText, setToastText] = useState("")
    const navigate = useNavigate();
    const location = useLocation();
    const navigationType = useNavigationType();

    // Новый экран (нижнее меню, ссылка) открывается сверху, а не на прокрутке прошлого
    // экрана; «назад» возвращает туда, где экран оставили (список восстанавливает
    // прокрутку сам, остальное — браузер). Эффект родителя срабатывает после
    // componentDidMount экранов, до отрисовки.
    useLayoutEffect(() => {
        if (navigationType !== 'POP') {
            window.scrollTo(0, 0);
        }
    }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

    // Текущий баланс без ожидания перерисовки — чтобы setMoney знал, на сколько он вырос.
    const moneyRef = useRef(state.count_money_r);
    useEffect(() => {
        moneyRef.current = state.count_money_r;
    }, [state.count_money_r]);

    const updateMoney = useCallback((money, title) => {
        // var mMoney = money
        // if (money >= 25){
        //     mMoney = Math.floor(mMoney / 25)
        // }
        console.log("updateMoney = ", money)
        // все вызовы updateMoney — начисление за выполненное задание: фейерверк и сумма
        // (событие раньше setState, чтобы шапка знала, что надо дождаться монет)
        celebrateEarned(money, title);
        moneyRef.current = parseFloat(moneyRef.current || 0) + parseFloat(money);
        setState(prev => ({
            ...prev,
            count_money_r: prev.count_money_r + parseFloat(money)
        }));
    }, []);

    const setMoney = useCallback((money) => {
        const before = parseFloat(moneyRef.current);
        const after = parseFloat(money);
        if (isFinite(before) && isFinite(after) && after - before > 0.0001) {
            celebrateSynced(after - before);
        }
        moneyRef.current = money;
        setState(prev => ({ ...prev, count_money_r: money }));
    }, []);

    const onTaskClicked = useCallback((task, path) => {
        setState(prev => ({
            ...prev,
            currentTask: task
        }));
        navigate(path + "?task_id=" + (task.order_id ? task.order_id : task._id));
    }, [navigate]);

    const toogleMenu = useCallback(() => {
        setState(prev => ({
            ...prev,
            isMenuOpened: !prev.isMenuOpened
        }));
    }, []);

    const onBack = useCallback(() => {
        navigate(-1);
    }, [navigate]);

    const onMenuClicked = useCallback((path) => {
        setState(prev => ({
            ...prev,
            isMenuOpened: false
        }));
        navigate(path);
    }, [navigate]);

    const openViewBack = useCallback((path) => {
        navigate(path);
    }, [navigate]);

    const onPayoutClicked = useCallback(() => {
        navigate('/payout');
    }, [navigate]);

    // Сведения о пользователе уже загружались: дальше обновляем их в фоне.
    const infoLoadedRef = useRef(false);
    const infoRequestedAtRef = useRef(0);

    const getMyInfo = useCallback(() => {
        infoRequestedAtRef.current = Date.now();
        // Полноэкранная загрузка — только при первом запуске, пока данных ещё нет.
        // Повторные обновления (кнопка «назад», после выплаты, открытие «Активных»)
        // идут в фоне: экран не мигает лоадером и не пересоздаётся заново.
        if (!infoLoadedRef.current) {
            setState(prev => (prev.done ? { ...prev, done: false } : prev));
        }

        UsersApi.getMyInfoEmployer((responseData) => {

            if (responseData.response > 0) {
                    infoLoadedRef.current = true;
                    setState(prev => ({
                        ...prev,
                        isRegistered: true,
                        count_money_r: responseData.employer.count_money_r,
                        nick_name: responseData.employer.nick_name,
                        photo_url: responseData.employer.photo_url,
                        email: responseData.employer.email,
                        google_user_id: responseData.employer.google_user_id,
                        info: responseData.employer,
                        ref_id: responseData.employer.ref_id,
                        wallet_new: responseData.employer.wallet_new,
                        min_transfer: responseData.employer.min_transfer,
                        instagram_user_name: responseData.employer.instagram_user_name,
                        done: true
                    }));
                    getMyNeedRework(responseData.employer)
                    // для скелета при следующем запуске: будет ли баннер «Привязать телеграм»
                    const tgChatId = responseData.employer.telegram_chat_id
                    rememberTelegramBound(tgChatId !== undefined && tgChatId !== null && tgChatId !== "")
                    // if (getUrlParameter("uniq_user_id") && (responseData.employer.easy_money_user_id == "undefined" || responseData.employer.easy_money_user_id == null || responseData.employer.easy_money_user_id == "" || responseData.employer.easy_money_user_id == undefined)) {
                    //     registerUser();
                    // }

                    const hasApiKey = getUrlParameter("api_key");
                    const api_key = getUrlParameter("api_key") ? getUrlParameter("api_key") : getCookie("api_key");
                    const isUpmob = hasApiKey ? ["upmob", "upmob_rustore", "lexus", "QWT", "QWT2"].includes(api_key) : true;
                    const isEmptyEasyMoneyUserID = getCookie("uniq_user_id") == "undefined" || getCookie("uniq_user_id") == null || getCookie("uniq_user_id") == "" || getCookie("uniq_user_id") == undefined;
                    
                    if (isEmptyEasyMoneyUserID && !isUpmob && getUrlParameter("uniq_user_id") && (responseData.employer.easy_money_user_id == "undefined" || responseData.employer.easy_money_user_id == null || responseData.employer.easy_money_user_id == "" || responseData.employer.easy_money_user_id == undefined)) {
                        registerUser();
                    }
                // registrationFailed("getMyInfoEmployer error = " + JSON.stringify(responseData));
            }
        }, (responseData) => {
            // ошибка фонового обновления — просто остаёмся с текущими данными
            if (!infoLoadedRef.current) {
                registrationFailed("getMyInfoEmployer error = " + JSON.stringify(responseData));
            }
        })
    }, []);

    // Тихое обновление (progress_orders, баланс) для списков «Активные» / «Выполненные»:
    // только что выполненное задание должно сразу уйти из «Активных».
    const refreshMyInfo = useCallback(() => {
        if (!infoLoadedRef.current) return;
        if (Date.now() - infoRequestedAtRef.current < 3000) return;   // только что обновляли
        getMyInfo();
    }, [getMyInfo]);
    const toastTimerRef = useRef(null);
    const showToast = useCallback((text) => {
        if (getIsAndroidApp()){
            return
        }
        if (toastTimerRef.current) {
            clearTimeout(toastTimerRef.current);
        }
        setToastText(text)
        toastTimerRef.current = setTimeout(() => {
            setToastText("")
            toastTimerRef.current = null
        }, 4000)
    }, [])

    // Очищаем висящий таймер тоста при размонтировании.
    useEffect(() => () => {
        if (toastTimerRef.current) {
            clearTimeout(toastTimerRef.current)
        }
    }, [])
    // Войти не удалось: ключа сессии нет и подтвердить вход нечем (токен Google из приложения
    // устарел, переходный период кончился). В приложении — сообщить ему (SDK закроет задания и
    // передаст ошибку приложению-партнёру, оно войдёт заново); на сайте — страница входа.
    const [authError, setAuthError] = useState(false);
    const authFailed = useCallback((result) => {
        // страница загрузки скриншотов (внешний браузер): ошибку покажет сама страница
        if (getUrlParameter("file_upload") == "true") return;
        // переходный период (сервер пускает без ключа почти везде) и приложение iPhone (пускает без
        // ключа всегда): приложение продолжает как есть, запрос, которому нужен ключ (вывод, чаты),
        // покажет текст сервера. Сайт же может войти заново через Google — туда и ведём.
        if (result && result.legacy && (getIsAndroidApp() || getIsIosApp())) return;
        if (getIsAndroidApp()) {
            registrationFailed("Войдите заново: вход не подтверждён (" + ((result && result.reason) || "auth_required") + ")");
            // если приложение само не закрыло задания — объясняем на экране
            setAuthError(true);
            return;
        }
        forgetWorker();
        if (!window.location.pathname.includes(Pages.auth)) {
            window.location.href = '/' + Pages.auth;
        }
    }, []);

    // Google ID есть, ключа сессии может не быть (вошли до обновления) — получить и продолжить
    const continueWithSession = useCallback((gid) => {
        ensureSession(gid).then((r) => {
            if (r.ok || r.legacy || r.network) {
                getMyInfo();
            } else {
                authFailed(r);
            }
        });
    }, [getMyInfo, authFailed]);

    // ответ сервера «нужен ключ» посреди работы (ключ отозван, переходный период кончился)
    useEffect(() => {
        setAuthFailedHandler(authFailed);
        return () => setAuthFailedHandler(null);
    }, [authFailed]);

    const registerUser = useCallback(() => {
        if (!getIsAndroidApp() && !getCookie("google_user_id") && !getUrlParameter("google_user_id")) {
            
            if (!window.location.pathname.includes(Pages.auth)) {
                window.location.href = Pages.auth
            }
            return
        }
        var params = getRequestParams()
        var device_id = getUrlParameter('device_id')
        var token_google = getUrlGoogleToken()
        var uniq_user_id = getUrlParameter('uniq_user_id')
        var api_key = getUrlParameter('api_key')
        var bundle = getUrlParameter('bundle')
        if (bundle != "" && bundle != undefined && bundle != null){
            saveBundle(bundle)
        }
        params.device_id = device_id
        params.token_google = token_google
        params.easy_money_user_id = uniq_user_id
        params.api_key = api_key
        params.bundle = bundle
        if (api_key == "lexus"){
            params.promo_id = "945113"
        } else if (api_key == "QWT"){
            params.promo_id = "2554224"
        } else if (api_key == "QWT2"){
            params.promo_id = "2719566"
        }
        fetch("https://app-coins.ru/api/registerEmployer", getHttpParams(params))
            .then((response) => response.json())
            .then((responseData) => {
                console.log("registerEmployer = ", responseData)
                if (responseData.status == "OK" && responseData.response > 0) {
                    saveRegistrCookie(responseData, device_id, uniq_user_id, api_key);
                    if (responseData.auth_token) {
                        saveSession(responseData.auth_token, responseData.google_user_id);
                        getMyInfo();
                    } else {
                        // вход по номеру пользователя партнёра без подтверждения — ключ по токену Google
                        continueWithSession(responseData.google_user_id);
                    }
                } else {
                    //showAndroidToast("registrationFailed = " + JSON.stringify(responseData.status))
                    registrationFailed("registerUser error = " +JSON.stringify(responseData));
                    
                }
                // if (responseData.response < 0){
                //     registrationFailed();
                // }
            });
    }, [getMyInfo, continueWithSession]);

    // Запуск, когда Google ID уже известен: ключ сессии есть — сразу к заданиям; нет — получить
    // по токену Google из адреса. Если приложение передало токен другого аккаунта (вышли и вошли
    // другим) — войти этим аккаунтом (один раз за запуск).
    const switchedRef = useRef(false);
    const startWithSession = useCallback(() => {
        const gid = getCookie("google_user_id");
        const sub = googleTokenSub(getUrlGoogleToken());
        if (sub && sub !== gid && /^\d{6,}$/.test(sub) && /^\d{6,}$/.test(gid || "") && !switchedRef.current) {
            switchedRef.current = true;
            forgetWorker();
            registerUser();
            return;
        }
        if (getSessionToken(gid)) {
            getMyInfo();
            return;
        }
        ensureSession(gid).then((r) => {
            if (r.ok || r.legacy || r.network) {
                getMyInfo();
            } else if (r.other && !switchedRef.current) {
                switchedRef.current = true;
                forgetWorker();
                registerUser();
            } else {
                authFailed(r);
            }
        });
    }, [getMyInfo, registerUser, authFailed]);

    const getMyNeedRework = useCallback((user) => {

        TasksApi.getOrdersWaitToAction(user.google_user_id, (responseData) => {
            if (responseData.response == 1) {
                var activeTasks = convertNeedReworkOrders(responseData.app_3_days).reverse() 
                var ytTasks = responseData.youtube_orders.proof_orders_youtube
                ytTasks.forEach(element => {
                    element.is_universal = true
                });
                activeTasks.push(...ytTasks)
                setNeedReworkTasks(activeTasks)
            } else {
                setNeedReworkTasks([])
            }
            console.log("getOrdersWaitToAction success = ", responseData)
        }, (responseData) => {
            setNeedReworkTasks([])
        })

    }, []);

    useEffect(() => {
        if (getUrlParameter("file_upload") == "true"){
            setState(prev => ({
                ...prev,
                done: true
            }));
            return
        }
        console.log("componentDidMount index");
        if (getUrlParameter("platform") == "ios") {
            setCookie("platform", "ios");
            if (getUrlGoogleToken() == "testasd0218938912") {
                setCookie("test_token", "testasd0218938912");
                getMyInfo()
                return
            }
            // getMyInfo();
            // return;
        }
        if (getUrlParameter("google_user_id")) {
            setCookie("google_user_id", getUrlParameter("google_user_id"));
            setCookie("device_id", getUrlParameter("device_id"));
            setCookie("api_key", getUrlParameter("api_key"));
            setCookie("platform", getUrlParameter("platform"));
            startWithSession();
            return;
        }
        if (!getGoogleId("google_user_id")) {
            registerUser();
        } else {
            startWithSession();
        }
    }, []);

    const firstPathRef = useRef(location.pathname);
    const navigatedRef = useRef(false);

    // Экран готов — в свободное время подгружаем код остальных экранов
    useEffect(() => {
        if (state.done) {
            preloadPages();
        }
    }, [state.done]);

    // Чаты: число непрочитанных для нижнего меню и сокет, по которому новые сообщения
    // приходят сразу. Сокет открывается, только если у исполнителя уже есть переписки
    // (или он открыл «Чаты»): у большинства их нет, и держать тысячи пустых соединений
    // незачем — о первом сообщении придёт push, а счётчик обновится при возврате в приложение
    // и раз в 3 минуты. При сокете без связи — раз в минуту.
    const [chatSocket, setChatSocket] = useState(null);
    const [chatUnread, setChatUnread] = useState(0);
    const [chatLive, setChatLive] = useState(false);
    const chatAllowed = state.done && state.isRegistered && getUrlParameter("file_upload") != "true" && !!getSessionToken(getCookie("google_user_id"));

    const refreshChatUnread = useCallback(() => {
        if (!getCookie("google_user_id")) return;
        ChatApi.unread().then((res) => {
            setChatUnread(res.unread || 0);
            if (res.total > 0 || res.unread > 0) setChatLive(true);
        }).catch(() => {});
    }, []);
    const unreadTimerRef = useRef(null);
    // не чаще раза в 400 мс, но и не откладывая бесконечно при потоке событий
    const scheduleChatUnread = useCallback(() => {
        if (unreadTimerRef.current) return;
        unreadTimerRef.current = setTimeout(() => { unreadTimerRef.current = null; refreshChatUnread(); }, 400);
    }, [refreshChatUnread]);
    const openChatLive = useCallback(() => setChatLive(true), []);

    useEffect(() => {
        if (!chatAllowed || !chatLive || !getCookie("google_user_id")) return undefined;
        const socket = createChatSocket({
            apiUrl: getRequestUrl(),
            getAuth: () => {
                const gid = getCookie("google_user_id");
                return gid ? { role: 'employer', google_user_id: gid, auth_token: getSessionToken(gid) } : null;
            }
        });
        setChatSocket(socket);
        return () => {
            socket.close();
            setChatSocket(null);
        };
    }, [chatAllowed, chatLive]);

    useEffect(() => {
        if (!chatSocket) return undefined;
        const off = chatSocket.on((msg) => {
            if (msg.type === 'ready') setChatUnread(msg.unread || 0);
            else if (msg.type === 'read') scheduleChatUnread();
            else if (msg.type === 'message' && !(msg.message && msg.message.from === 'employer')) scheduleChatUnread();
        });
        return () => {
            off();
            clearTimeout(unreadTimerRef.current);
            unreadTimerRef.current = null;
        };
    }, [chatSocket, scheduleChatUnread]);

    // без сокета (или без связи) — опрос, пока приложение на экране, и сразу при возврате в него
    useEffect(() => {
        if (!chatAllowed) return undefined;
        const tick = () => {
            if (document.hidden) return;
            if (chatSocket && chatSocket.isOnline()) return;
            refreshChatUnread();
        };
        tick();
        const timer = setInterval(tick, chatSocket ? 60000 : 180000);
        const onVisible = () => { if (!document.hidden) tick(); };
        document.addEventListener('visibilitychange', onVisible);
        return () => {
            clearInterval(timer);
            document.removeEventListener('visibilitychange', onVisible);
        };
    }, [chatAllowed, chatSocket, refreshChatUnread]);

    // Рейтинг и награда за ежедневный вход (свои приложения, не партнёрские): после загрузки
    // сведений о пользователе — «вход за день» (сервер начислит раз в день по Москве) и окно:
    // сначала о снижении за «чушь», потом о награде. Пока приложение открыто, повторяем при
    // возврате в него — не чаще раза в час, но сразу, если по Москве уже новый день, — и в
    // московскую полночь, если приложение так и не закрывали.
    const [rating, setRating] = useState(null);
    const [ratingQueue, setRatingQueue] = useState([]);
    const ratingCheckedRef = useRef({ at: 0, day: '' });
    const shownRatingNewsRef = useRef(new Set());
    const ratingAllowed = state.done && state.isRegistered && state.isUpmob && getUrlParameter("file_upload") != "true";
    const ratingCheckin = useCallback(() => {
        if (!getCookie("google_user_id") && !getGoogleId("google_user_id")) return;
        const today = mskDay();
        const last = ratingCheckedRef.current;
        if (last.day === today && Date.now() - last.at < 3600000) return;
        ratingCheckedRef.current = { at: Date.now(), day: today };
        RatingApi.checkin((res) => {
            setRating(res.rating);
            // окно о «чуши» — один раз за запуск, даже если сервер ещё не узнал, что его показали
            const news = (res.news || []).filter((n) => !shownRatingNewsRef.current.has(n.id));
            news.forEach((n) => shownRatingNewsRef.current.add(n.id));
            const next = [];
            if (news.length) next.push({ kind: 'penalty', news });
            if (res.reward) next.push({ kind: 'reward', reward: res.reward, rating: res.rating });
            if (next.length) setRatingQueue((q) => q.concat(next));
        }, () => { ratingCheckedRef.current = { at: 0, day: '' }; });
    }, []);
    useEffect(() => {
        if (!ratingAllowed) return undefined;
        ratingCheckin();
        const onVisible = () => { if (!document.hidden) ratingCheckin(); };
        document.addEventListener('visibilitychange', onVisible);
        let timer = 0;
        const armMidnight = () => {
            timer = setTimeout(() => {
                if (!document.hidden) ratingCheckin();
                armMidnight();
            }, msUntilMskMidnight() + 5000);
        };
        armMidnight();
        return () => {
            document.removeEventListener('visibilitychange', onVisible);
            clearTimeout(timer);
        };
    }, [ratingAllowed, ratingCheckin]);
    const nextRatingPopup = useCallback(() => setRatingQueue((q) => q.slice(1)), []);

    const celebration = <Celebration isUpmob={state.isUpmob} />;

    // Первый запуск: пока грузятся сведения о пользователе, показываем «каркас»
    // приложения — шапку (баланс мерцает заглушкой), нижнее меню и скелет экрана —
    // вместо белого экрана со спиннером. Когда данные пришли, на те же места
    // встаёт настоящий экран: ничего не мигает и не прыгает.
    const booting = !state.done && !window.location.pathname.includes(Pages.auth);
    // веб без входа: шапки нет, и сейчас откроется страница входа — скелет не нужен
    // (как и «каркас» в index.html)
    const isUnauthorizedWeb = !getIsAndroidApp() && !getCookie("google_user_id") && !getUrlParameter("google_user_id");

    // Первый экран после загрузки сменяет скелет на месте — без «наплыва»;
    // мягкое проявление — только при переходах между экранами.
    if (booting) {
        firstPathRef.current = location.pathname;
    } else if (firstPathRef.current !== location.pathname) {
        navigatedRef.current = true;
    }

    return (
        <React.Fragment>
        <div>
            {(window.location.hostname !== 'localhost') && 
                <YMInitializer 
                    accounts={[86575405]}
                    options={{webvisor: false, clickmap:true, trackLinks:true, accurateTrackBounce:true}}
                />
            }
            <div className="app">
                {/* <MaterialMenuAndroid 
                    activeView={state.activeView} 
                    toogleMenu={toogleMenu} 
                    isMenuOpened={state.isMenuOpened} 
                    onMenuClicked={onMenuClicked} 
                    isUpmob={state.isUpmob} 
                    count_money_r={state.count_money_r} 
                    name={state.nick_name} 
                    photo={state.photo_url} 
                    email={state.email} 
                    google_user_id={state.google_user_id}
                /> */}
                <div className="main">
                    {(!getUrlParameter("file_upload") && !(!getIsAndroidApp() && !getCookie("google_user_id") && !getUrlParameter("google_user_id"))) &&
                    <Navbar 
                        toogleMenu={toogleMenu} 
                        onBack={onBack} 
                        isClose={state.isClose} 
                        isUpmob={state.isUpmob} 
                        count_money_r={state.count_money_r}
                        balanceLoading={booting}
                        getMyInfo={getMyInfo}
                        chatUnread={chatUnread}
                    />}
                    <section className='main_container_center'>
                        {authError ? (
                            <div className="auth_error" role="alert">
                                <div className="auth_error_title">Не удалось подтвердить вход</div>
                                <div className="auth_error_text">Баланс и задания сохранятся — они привязаны к вашему аккаунту Google.</div>
                                <ol className="auth_error_steps">
                                    <li>Полностью закройте приложение (уберите его из списка недавних) и откройте снова.</li>
                                    <li>Не помогло — откройте настройки телефона: «Приложения» → это приложение → «Память» (или «Хранилище») → «Очистить данные». Затем откройте приложение и войдите тем же аккаунтом Google.</li>
                                </ol>
                            </div>
                        ) : booting ? (isUnauthorizedWeb ? null : <RouteSkeleton pathname={location.pathname} banners={{ telegram: !isTelegramBoundCached(), logout: getIsAndroid() && state.isUpmob }} />) :
                        <Suspense fallback={<RouteSkeleton pathname={location.pathname} />}>
                        {/* key по пути — при переходе экран мягко проявляется заново */}
                        <div key={location.pathname} className={navigatedRef.current ? "screen screen_enter" : "screen"}>
                        <Routes>
                            <Route 
                                path={`/${Pages.tasks}`}
                                element={
                                    state.isRegistered && (
                                        <Tasks 
                                            updateMoney={updateMoney} 
                                            wallet_new={state.wallet_new} 
                                            count_money_r={state.count_money_r} 
                                            readyToTasks={state.isRegistered} 
                                            instaUsername={state.instagram_user_name} 
                                            openViewBack={openViewBack} 
                                            onTaskClicked={onTaskClicked} 
                                            isUpmob={state.isUpmob}
                                            info={state.info}
                                            refreshInfo={refreshMyInfo}
                                            restoreView={navigationType === 'POP'}
                                        />
                                    )
                                }
                            />

                            {!getIsAndroidApp() && <Route
                                path={`/${Pages.auth}`} 
                                element={
                                    <Auth 
                                        onBack={onBack} 
                                        task={state.currentTask} 
                                        updateMoney={updateMoney}
                                        isUpmob={state.isUpmob}
                                    />
                                } 
                            />}
                            <Route 
                                path={`/${Pages.task}`} 
                                element={
                                    <Task 
                                        onBack={onBack} 
                                        task={state.currentTask} 
                                        updateMoney={updateMoney}
                                        
                                        isUpmob={state.isUpmob}
                                    />
                                } 
                            />
                            <Route 
                                path={`/${Pages.task_garanted_review}`} 
                                element={
                                    <TaskNewAndroid 
                                        onBack={onBack} 
                                        task={state.currentTask} 
                                        updateMoney={updateMoney}
                                        
                                        isUpmob={state.isUpmob}
                                    />
                                } 
                            />
                            <Route 
                                path={`/${Pages.task_ios}`} 
                                element={
                                    <TaskIos 
                                        onBack={onBack} 
                                        task={state.currentTask} 
                                        updateMoney={updateMoney}
                                        isUpmob={state.isUpmob}
                                        showToast={showToast}
                                    />
                                } 
                            />

                            <Route 
                                path={`/${Pages.active}`} 
                                element={
                                    <ActiveTasks 
                                        onTaskClicked={onTaskClicked} 
                                        info={state.info}
                                        refreshInfo={refreshMyInfo}
                                    />
                                } 
                            />

                            <Route 
                                path={`/${Pages.finished}`} 
                                element={
                                    <FinishedTasks 
                                        onTaskClicked={onTaskClicked} 
                                        info={state.info}
                                        refreshInfo={refreshMyInfo}
                                    />
                                } 
                            />

                            <Route 
                                path={`/${Pages.referals}`}
                                isUpmob={state.isUpmob} 
                                element={<Referals ref_id={state.ref_id}/>} 
                            />

                            <Route 
                                path={`/${Pages.payouts}`} 
                                isUpmob={state.isUpmob}
                                element={<Payouts isUpmob={state.isUpmob} onPayoutClicked={onPayoutClicked}/>} 
                            />

                            <Route 
                                path={`/${Pages.payout}`} 
                                element={
                                    <GetPayout 
                                        isUpmob={state.isUpmob}
                                        wallet_new={state.wallet_new} 
                                        updateMoney={updateMoney} 
                                        min_transfer={state.min_transfer} 
                                        count_money_r={state.count_money_r}
                                        getMyInfo={getMyInfo}
                                    />
                                } 
                            />

                            <Route 
                                path={`/${Pages.support}`} 
                                element={
                                    <Support 
                                        isUpmob={state.isUpmob} 
                                        google_user_id={state.google_user_id}
                                    />
                                } 
                            />

                            <Route 
                                path={`/${Pages.auth_insta}`} 
                                element={<AuthInsta openViewBack={openViewBack}/>} 
                            />

                            <Route 
                                path={`/${Pages.earn_insta}`} 
                                element={
                                    <EarnInsta 
                                        openViewBack={openViewBack} 
                                        setMoney={setMoney}
                                    />
                                } 
                            />

                            <Route 
                                path={`/${Pages.tiktok_task}`} 
                                element={<EarnTikTok setMoney={setMoney}/>} 
                            />

                            <Route 
                                path={`/${Pages.custom_task}`} 
                                element={
                                    <CustomTask 
                                        task={state.currentTask} 
                                        openViewBack={openViewBack} 
                                        updateMoney={updateMoney}
                                        isUpmob={state.isUpmob}
                                        showToast={showToast}
                                    />
                                } 
                            />
                            <Route 
                                path={`/${Pages.profile}`} 
                                element={
                                    <Profile 
                                        isUpmob={state.isUpmob}
                                        rating={rating}
                                        onRating={setRating}
                                        user={state.info} 
                                        refreshInfo={refreshMyInfo}
                                        showToast={showToast}
                                        openViewBack={openViewBack} 
                                        updateMoney={updateMoney}
                                        onTaskClicked={onTaskClicked}
                                    />
                                } 
                            />
                            <Route 
                                path={`/${Pages.rating}`} 
                                element={<RatingPage initial={rating} onRating={setRating} />} 
                            />
                            <Route 
                                path={`/${Pages.lottery}`} 
                                element={<LotteryPage isUpmob={state.isUpmob} updateMoney={updateMoney} refreshInfo={refreshMyInfo} />} 
                            />
                            <Route 
                                path={`/${Pages.more}`} 
                                element={
                                    <More 
                                        isUpmob={state.isUpmob}
                                        user={state.info} 
                                        openViewBack={openViewBack} 
                                        updateMoney={updateMoney}
                                        onTaskClicked={onTaskClicked}
                                    />
                                } 
                            />
                            <Route 
                                path={`/${Pages.need_rework}`} 
                                element={
                                    <NeedRework 
                                        isUpmob={state.isUpmob}
                                        user={state.info} 
                                        needReworkTasks={needReworkTasks}
                                        openViewBack={openViewBack} 
                                        updateMoney={updateMoney}
                                        onTaskClicked={onTaskClicked}
                                    />
                                } 
                            />
                            <Route
                                path={`/${Pages.chats}`}
                                element={
                                    <Chats
                                        chatSocket={chatSocket}
                                        showToast={showToast}
                                        onUnreadChanged={scheduleChatUnread}
                                        onOpen={openChatLive}
                                        onTaskClicked={onTaskClicked}
                                        info={state.info}
                                    />
                                }
                            />
                             <Route 
                                path={`/${Pages.file_upload}`} 
                                element={
                                    <FileUploadPage 
                                       
                                    />
                                } 
                            />
                            {/* скриншот отзыва (задание «Напишите отзыв»), открывается во внешнем браузере */}
                            <Route path={`/${Pages.review_shot}`} element={<ReviewShotPage />} />
                        </Routes>
                        </div>
                        </Suspense>}
                        {isShowBottomMenu() && <BottomMenu needReworkTasks={needReworkTasks} user={state.info} chatUnread={chatUnread}/>}
                        {toastText != "" && <Toast text={toastText}/>}
                    </section>
                </div>
            </div>
        </div>
        {celebration}
        {!booting && ratingAllowed && <RatingPopup items={ratingQueue} rating={rating} onDone={nextRatingPopup} />}
        </React.Fragment>
    );
}

function AppWrapper() {
    if (getIsAndroidApp()){
        return(
            <BrowserRouter>
                <Application />
            </BrowserRouter>
        )
    }
    return (
        <GoogleOAuthProvider clientId='1061951330704-tous6uameesl102ik54gl1nhb5tbl6l1.apps.googleusercontent.com'>
            <BrowserRouter>
                <Application />
            </BrowserRouter>
        </GoogleOAuthProvider>
    );
}

// Отклик на нажатия (вдавливание, волна, «занято») для всех кликабельных элементов
installPressFeedback();
// Иконки заданий проявляются по мере загрузки
installImageReveal();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<AppWrapper />);

// Глобальные обработчики
window.onResume = () => {
    console.log("onResume index");
    const tasks = [
        window.firstTask,
        window.secondTask,
        window.thirdTask,
        window.fouthTask,
        window.fifthTask,
        window.extraView,
        window.photoTask,
        window.extraFollow,
        window.extraComment,
        window.customTask,
        window.sdkTask
    ];

    tasks.forEach(task => {
        if (task !== undefined) {
            task.onResume();
        }
    });
};

window.handleImage = (image) => {
    if (window.tasks !== undefined) {
        window.tasks.handleImage(image);
    }
};

export default AppWrapper;


